import { hasRoles } from '@m/services/keycloak/iamRoles';
import { RoleName, RoleNameValue } from '@m/types/api/iam/Iam';

// Display surveys are for Managers and above — not Customer Support.
// LEADER, SUPER_ADMIN, and SYSTEM_ADMIN are listed explicitly because role
// inheritance in iamRoles.ts is single-level and does not reach MANAGER for them.
export const DISPLAY_SURVEY_ROLES: RoleNameValue[] = [
  RoleName.MANAGER,
  RoleName.LEADER,
  RoleName.OPERATIONAL_ADMIN,
  RoleName.SUPER_ADMIN,
  RoleName.SYSTEM_ADMIN,
];

export const canAccessDisplaySurvey = () => hasRoles(DISPLAY_SURVEY_ROLES);
